import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { useApolloClient } from '@apollo/react-hooks';
import { useCallback, useMemo } from 'react';
import { RETRIEVE_DEFAULT_COUPON_MAPPING } from '../../graphql';
import useRetrieveDefaultCouponMapping from './useRetrieveDefaultCouponMapping';
export const useFetchDefaultCouponCode = () => {
  const client = useApolloClient();
  return useCallback(function () {
    var _ref = _asyncToGenerator(function* (defaultCoupon = '', defaultCouponType = '') {
      var _data$defaultCouponMa, _data$defaultCouponMa2;

      if (defaultCoupon) {
        return defaultCoupon;
      }

      if (!defaultCouponType) {
        return '';
      }

      const {
        data
      } = yield client.query({
        query: RETRIEVE_DEFAULT_COUPON_MAPPING,
        variables: {
          type: defaultCouponType
        },
        fetchPolicy: 'cache-first'
      });
      return (_data$defaultCouponMa = data === null || data === void 0 ? void 0 : (_data$defaultCouponMa2 = data.defaultCouponMapping) === null || _data$defaultCouponMa2 === void 0 ? void 0 : _data$defaultCouponMa2.coupon_code) !== null && _data$defaultCouponMa !== void 0 ? _data$defaultCouponMa : '';
    });

    return function () {
      return _ref.apply(this, arguments);
    };
  }(), [client]);
};
export const useDefaultCouponCode = (defaultCoupon, defaultCouponType) => {
  const [defaultCouponMapping, retrieve] = useRetrieveDefaultCouponMapping(defaultCouponType, {
    skip: !defaultCouponType || !!defaultCoupon,
    fetchPolicy: 'cache-first'
  });
  return useMemo(() => [defaultCoupon || (defaultCouponMapping === null || defaultCouponMapping === void 0 ? void 0 : defaultCouponMapping.coupon_code) || '', retrieve], [defaultCoupon, defaultCouponMapping === null || defaultCouponMapping === void 0 ? void 0 : defaultCouponMapping.coupon_code, retrieve]);
};